import React from 'react';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend,
} from 'chart.js';
import { Line } from 'react-chartjs-2';
import {useDispatch, useSelector} from "react-redux";


  
function LineChart({ data, title, legend=true, xLabel="", yLabel="", dateFormat="year" }) {

    ChartJS.register(
        CategoryScale,
        LinearScale,
        PointElement,
        LineElement,
        Title,
        Tooltip,
        Legend
    );

    const options = {
        responsive: true,
        plugins: {
            legend: legend && {
                position: 'top' ,
            },
            title: {
                display: true,
                text: title,
            },
        },
        scales: {
            
            y: {
                ticks: {
                    callback: function(value, index, ticks) {
                        return value +yLabel;
                    }
                }
            }
        }
        
    };

    const locale = useSelector(state => state.locale);

    const LineData = {
        labels: data[0].data.map((d) => dateFormat === "month"? new Date(d.xLabel).toLocaleDateString(locale, { month: 'short', year: 'numeric' }) + xLabel : new Date(d.xLabel).getFullYear() + xLabel),
        datasets: data.map((d) => {
            return {
                label: d.label,
                data: d.data.map((elm) => elm.value),
                borderColor: d.borderColor,
                backgroundColor: d.backgroundColor,
                borderDash: d.borderDash,
                radius :10
            };
        }),
    }


    return (
        <Line options={options} data={LineData} />
    );
}

export default LineChart;
